
import { Component, Vue } from "vue-property-decorator";
import { SW_CASES_HOTJAR_SITE_ID } from "@/constants/hotjar";
import { SMAdditionalInfo, SMHotjar } from "@/store";

SMHotjar.initHotjar(SW_CASES_HOTJAR_SITE_ID);

@Component({
  components: {
    // WidgetDependantVisa: () =>
    //   import("@/modules/Services/Components/Widgets/WidgetDependantVisa.vue"),
    PricingRequestsPopups: () => import("@/modules/Pricing/Requests/PricingRequestsPopups.vue"),
  },
})
export default class Candidate extends Vue {
  // TEMP: Uncomment for demonstrate example;
  // async mounted() {
  //   await this.$nextTick();
  //
  //   setTimeout(() => {
  //     this.initTour();
  //   }, 1000);
  // }

  get dependantsList() {
    return SMAdditionalInfo.dependantsList;
  }

  mounted() {
    SMAdditionalInfo.fetchDependantsList();
  }

  initTour() {
    const tour = this.$shepherd({
      useModalOverlay: true,
      defaultStepOptions: {
        classes: "shepherd-theme-custom",
        scrollTo: true,
        popperOptions: {
          modifiers: [{ name: "offset", options: { offset: [0, 28] } }],
        },
        modalOverlayOpeningPadding: 12,
      },
    });

    const rootEl = this.$root.$el;

    const buttons = [
      {
        text: "Next",
        action: tour.next,
      },
    ];

    const summaryTabEl = rootEl.querySelector("#summary_tab");
    summaryTabEl &&
      tour.addStep({
        attachTo: { element: summaryTabEl as HTMLElement, on: "bottom" },
        text: "Summary tab",
        buttons,
      });

    const personalDetailsTabEl = rootEl.querySelector("#personal_details_tab");
    personalDetailsTabEl &&
      tour.addStep({
        attachTo: { element: personalDetailsTabEl as HTMLElement, on: "bottom" },
        text: "Personal details tab",
        buttons,
      });

    const employmentTabEl = rootEl.querySelector("#employment_tab");
    employmentTabEl &&
      tour.addStep({
        attachTo: { element: employmentTabEl as HTMLElement, on: "bottom" },
        text: "Employment tab",
        buttons,
      });

    const documentsTabEl = rootEl.querySelector("#documents_tab");
    documentsTabEl &&
      tour.addStep({
        attachTo: { element: documentsTabEl as HTMLElement, on: "bottom" },
        text: "Documents tab",
        buttons,
      });

    const finalApplicationTabEl = rootEl.querySelector("#final_application_tab");
    finalApplicationTabEl &&
      tour.addStep({
        attachTo: { element: finalApplicationTabEl as HTMLElement, on: "bottom" },
        text: "Final application tab",
        buttons,
      });

    const highlightWidgetEl = rootEl.querySelector("#highlight");
    highlightWidgetEl &&
      tour.addStep({
        attachTo: { element: highlightWidgetEl as HTMLElement, on: "top" },
        text: "This is highlight widget...",
        buttons,
      });

    const progressEl = rootEl.querySelector("#progress");
    progressEl &&
      tour.addStep({
        attachTo: { element: progressEl as HTMLElement, on: "top" },
        text: "This is progress widget...",
        buttons,
      });

    const caseCompletionEl = rootEl.querySelector("#case_completion");
    caseCompletionEl &&
      tour.addStep({
        attachTo: { element: caseCompletionEl as HTMLElement, on: "top" },
        text: "This service completion widget...",
        buttons,
      });

    const tasksEl = rootEl.querySelector("#tasks");
    tasksEl &&
      tour.addStep({
        attachTo: { element: tasksEl as HTMLElement, on: "top" },
        text: "This is tasks table...",
        buttons,
      });

    tour.start();
  }

  showDependantVisaWidget = false;
}
